import { render, staticRenderFns } from "./service-card-plan.vue?vue&type=template&id=2a680801&scoped=true&"
import script from "./service-card-plan.vue?vue&type=script&lang=js&"
export * from "./service-card-plan.vue?vue&type=script&lang=js&"
import style0 from "./service-card-plan.vue?vue&type=style&index=0&id=2a680801&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a680801",
  null
  
)

export default component.exports